import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { DataLinkService } from './data-link.service';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
  ],
  providers: [
    DataLinkService
  ],
})
export class DataLinkModule { }
